import { Directive, TemplateRef, Input } from '@angular/core';

@Directive({
  selector: '[mcGridHeaderMenu]'
})
export class GridHeaderMenuDirective {
  @Input('mcGridHeaderMenu') templateName: string;
  constructor(public templateRef: TemplateRef<any>) { }
}
